export const SUGGESTED_DARE_PROMPT_CONFIG = {
    enabled: true,
    minIntervalHours: 72,
    snoozeHours: 24,
    dismissDropDays: 30,
    candidatePoolSize: 5,
    minSimilarityScore: 0.1,
    similarityRatio: 0.3,
    showDelaySeconds: 15,
};
